export default __webpack_public_path__ + "static/media/1N.0ecacd05.jpg";